import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { LucideIcon } from "lucide-react"
import { Link } from "@/lib/page-rendering"
import { useId } from "react"

export function NavigationCard({
  Icon,
  href,
  title,
  description,
}: {
  Icon: LucideIcon
  href: string
  title: string
  description: string
}) {
  const titleId = useId()
  return (
    <Link href={href} className="flex grow" aria-labelledby={titleId}>
      <Card hoverable className="w-full">
        <CardHeader className="flex flex-row items-center justify-between align-bottom">
          <CardTitle id={titleId}>{title}</CardTitle>
          <Icon className="fill-brand-wise-green size-8" />
        </CardHeader>
        <CardContent>{description}</CardContent>
      </Card>
    </Link>
  )
}
